import PropTypes from 'prop-types';
import { memo, useMemo } from 'react';

import { ReactComponent as LightLogo } from '../../assets/logo-light.svg';
import { ReactComponent as Logo } from '../../assets/logo.svg';
import { ReactComponent as VinmecLogo } from '../../assets/vinmec.svg';

import { useThemeContext } from './ThemeProvider';

const LogoMapping = {
  default: {
    light: LightLogo,
    dark: Logo,
  },
  vinmec: {
    light: VinmecLogo,
    dark: VinmecLogo,
  },
};

const VindocLogo = ({ imgSrc }) => {
  const { theme } = useThemeContext();

  const origin = window.AGENCY || 'default';

  const LogoSrc = useMemo(() => {
    const themeDefinition = LogoMapping[origin];
    return imgSrc ? imgSrc : themeDefinition?.[theme] || Logo;
  }, [imgSrc, origin, theme]);

  // return React.createElement(LogoSrc);
  return (
    <LogoSrc
      style={{
        height: 32,
      }}
    />
  );
};

VindocLogo.propTypes = {
  imgSrc: PropTypes.string,
};

export default memo(VindocLogo);
